import { useEffect, useState } from "react";
import { Badge, Drawer, List, Typography, Avatar, Space, Button } from "antd";
import { LinkedinOutlined, UserOutlined } from "@ant-design/icons";
import axios from "axios";

const { Text, Link, Paragraph } = Typography;

const LinkedInProfiles = ({ backUrl, authData, mrfNo }) => {
    const [open, setOpen] = useState(false);
    const [profiles, setProfiles] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchProfiles = async () => {
        try {
            setLoading(true);
            const res = await axios.get(
                `${backUrl}/api/emp/manpowerrequisitions/${mrfNo}/source_candidates/`,
                {
                    headers: {
                        Authorization: `Bearer ${authData?.access}`,
                    },
                }
            );
            setProfiles(res.data.candidates || []);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProfiles();
    }, []);

    return (
        <>
            {/* Floating LinkedIn Button */}
            <div
                onClick={() => setOpen(true)}
                style={{
                    position: "fixed",
                    bottom: 150,
                    right: 60,
                    zIndex: 2000,
                    background: "#0A66C2",
                    color: "white",
                    padding: "16px",
                    borderRadius: "50%",
                    cursor: "pointer",
                    boxShadow:
                        "0 10px 20px rgba(0,0,0,0.35), 0 6px 6px rgba(0,0,0,0.22)",
                }}
            >
                <Badge count={profiles.length} size="small">
                    <LinkedinOutlined style={{ fontSize: 26, color: "white" }} />
                </Badge>
            </div>

            {/* Drawer */}
            <Drawer
                title={
                    <Space>
                        <LinkedinOutlined style={{ color: "#0A66C2" }} />
                        LinkedIn Candidates
                    </Space>
                }
                placement="right"
                width={500}
                onClose={() => setOpen(false)}
                open={open}
            >
                <List
                    loading={loading}
                    dataSource={profiles}
                    locale={{ emptyText: "No LinkedIn profiles found" }}
                    renderItem={(item, index) => (
                        <List.Item
                            key={index}
                            style={{
                                border: "1px solid #f0f0f0",
                                borderRadius: 12,
                                padding: 16,
                                marginBottom: 16,
                                background: "#fff",
                            }}
                        >
                            <section style={{ display: 'flex', flexDirection: 'column', justifyContent:'center' }}>
                                <div>
                                    <img style={{ width: '200px', height: '200px', borderRadius:'50%' }} src={item.image_url} alt="Image" />
                                </div>
                                <div>
                                    <Space align="start" size={16}>
                                        {/* Avatar */}

                                        {/* Content */}
                                        <div style={{ flex: 1 }}>
                                            <Text strong style={{ fontSize: 15 }}>
                                                {item.title}
                                            </Text>

                                            <Paragraph
                                                type="secondary"
                                                style={{ marginTop: 6, marginBottom: 10 }}
                                                ellipsis={{ rows: 2 }}
                                            >
                                                {item.snippet}
                                            </Paragraph>

                                            <Space size="middle">
                                                <Text type="secondary" style={{ fontSize: 12 }}>
                                                    Source: {item.source}
                                                </Text>

                                                <Link href={item.link} target="_blank">
                                                    <Button
                                                        type="primary"
                                                        size="small"
                                                        icon={<LinkedinOutlined />}
                                                        style={{ background: "#0A66C2" }}
                                                    >
                                                        View Profile
                                                    </Button>
                                                </Link>
                                            </Space>
                                        </div>
                                    </Space>
                                </div>
                            </section>


                        </List.Item>
                    )}
                />
            </Drawer>
        </>
    );
};

export default LinkedInProfiles;
